import lays from '../../../assets/images/cart-assets/lays/lays.png';
import strawberries from '../../../assets/images/cart-assets/strawberries/strawberries.jpg';
import tomatoes from '../../../assets/images/cart-assets/tomatoes/tomatoes.jpg';
import saffola from '../../../assets/images/cart-assets/saffola/saffola.jpg';


export const orderSummary = [
    {
        "id" : 1,
        "orderTitle" : "Saffola Active Pro Weight Watchers",
        "orderImage" : saffola,
        "orderCurrencyType" : "AED",
        "orderPrice" : "13.40"
    },
    {
        "id" : 2,
        "orderTitle" : "Drissoll's Strawberries 250gms",
        "orderImage" : strawberries,
        "orderCurrencyType" : "AED",
        "orderPrice" : "20.40"
    },
    {
        "id" : 3,
        "orderTitle" : "Lays Tomato Ketchup Chips 40gms",
        "orderImage" : lays,
        "orderCurrencyType" : "AED",
        "orderPrice" : "13.40"
    },
    {
        "id" : 4,
        "orderTitle" : "Round Tomato (Lowest Price)",
        "orderImage" : tomatoes,
        "orderCurrencyType" : "AED",
        "orderPrice" : "3.45"
    },
    {
        "id" : 5,
        "orderTitle" : "Round Tomato (Lowest Price)",
        "orderImage" : tomatoes,
        "orderCurrencyType" : "AED",
        "orderPrice" : "3.45"
    }


]

export const quickAdd = [
    {
        "id" : 1,
        "name" : "Vegetables"
    },
    {
        "id" : 2,
        "name" : "Fresh"
    },
    {
        "id" : 3,
        "name" : "Cooking & Ingredients"
    },
    {
        "id" : 4,
        "name" : "Breakfast & Snacks"
    },
    {
        "id" : 5,
        "name" : "Frogen"
    },
    {
        "id" : 6,
        "name" : "Beverages"
    },
    {
        "id" : 7,
        "name" : "Healthy & Beauty"
    },
    {
        "id" : 8,
        "name" : "Baby"
    },
    {
        "id" : 9,
        "name" : "Household"
    },
    {
        "id" : 10,
        "name" : "Pets"
    },
    {
        "id" : 11,
        "name" : "Home & Life"
    },

]